import React, { SFC } from "react";
import "./style.scss";
import ContentWrap from '../ContentWrap';

type PropsType = {
    videoUrl: string;
};

const Video = (props): SFC => (
    <div className="Video">
        <ContentWrap>
            <div className="Video__wrap">
                <iframe allowFullScreen src={props.videoUrl}></iframe>
            </div>
        </ContentWrap>
    </div>
);

export default Video;
